module.exports = __webpack_public_path__ + "img/eth-dark-logo.700b9e3c.svg";